import axios from "axios";
import { backend } from "../config/backend";

const API = axios.create({ baseURL: backend.urlEndPoint });

API.interceptors.request.use((req) => {
	if (localStorage.getItem("profile")) {
		req.headers.authorization = `Bearer ${localStorage.getItem("profile").token}`;
	}
	return req;
});

export const getAgentDashboardBalances = async (token, id) => {
	return await API.post(
		"/admin/agent/balancesdashboard",
		{
			token,
			id,
		},
		{
			headers: {
				"Content-Type": "application/json; charset=utf-8",
			},
		}
	);
};

export const getAgentsMaintenance = async (token) => {
	return await API.post(
		"/admin/agent/getagentsadmin",
		{
			token,
		},
		{
			headers: {
				"Content-Type": "application/json; charset=utf-8",
			},
		}
	);
};

export const agentLogin = async (username, password, ipAddress) => {
	return await API.post(
		"/admin/agent/login",
		{
			username,
			password,
			ipAddress
		},
		{
			headers: {
				"Content-Type": "application/json; charset=utf-8",
			},
		}
	);
};

export const updateInsertAgent = async (token, agent, edit) => {
	return await API.post(
		"/admin/agent/updateinsert",
		{
			token,
			agent,
			edit,
		},
		{
			headers: {
				"Content-Type": "application/json; charset=utf-8",
			},
		}
	);
};

export const verifyTwoFactCode = async (token, pin) => {
	return await API.post(
		"/admin/agent/verifytwofactcode",
		{
			token,
			pin,
		},
		{
			headers: {
				"Content-Type": "application/json; charset=utf-8",
			},
		}
	);
};

export const agentChangePassword = async (token, password, newpassword) => {
	return await API.post(
		"/admin/agent/changepassword",
		{
			token,
			password,
			newpassword,
		},
		{
			headers: {
				"Content-Type": "application/json; charset=utf-8",
			},
		}
	);
};

export const getAgentTwoFactorInfo = async (token) => {
	return await API.post(
		"/admin/agent/twofactorverify",
		{
			token,
		},
		{
			headers: {
				"Content-Type": "application/json; charset=utf-8",
			},
		}
	);
};

export const getAgentTwoFactorActive = async (token, active) => {
	return await API.post(
		"/admin/agent/twofactorverifyactive",
		{
			token,
			active,
		},
		{
			headers: {
				"Content-Type": "application/json; charset=utf-8",
			},
		}
	);
};

export const getAgentCustomers = async (token) => {
	return await API.post(
		"/admin/agent/customers",
		{
			token,
		},
		{
			headers: {
				"Content-Type": "application/json; charset=utf-8",
			},
		}
	);
};

export const getAgentCryptoCurrencies = async (token) => {
	return await API.post(
		"/admin/agent/getcryptocurrencies",
		{
			token,
		},
		{
			headers: {
				"Content-Type": "application/json; charset=utf-8",
			},
		}
	);
};

export const getAgentType = async (token) => {
	return await API.post(
		"/admin/agent/getagentype",
		{
			token,
		},
		{
			headers: {
				"Content-Type": "application/json; charset=utf-8",
			},
		}
	);
};

export const getAgentsByAgentMerchant = async (token) => {
	return await API.post(
		"/admin/agent/getagentsbyagentmerchant",
		{
			token,
		},
		{
			headers: {
				"Content-Type": "application/json; charset=utf-8",
			},
		}
	);
};

export const updateAgentCryptoCurrency = async (token, cryptoCurrency, network, activeDepositform, activeWithdrawalform, freeplayform, freeplayamountform) => {
	return await API.post(
		"/admin/agent/updatecryptocurrency",
		{
			token,
			cryptoCurrency,
			network,
			activeDepositform,
			activeWithdrawalform,
			freeplayform,
			freeplayamountform,
		},
		{
			headers: {
				"Content-Type": "application/json; charset=utf-8",
			},
		}
	);
};
